import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        "primary-purple": "#422264",
        "secondary-purple": "#f3f4f7",
        "tertiary-purple": "#EDE8F2",
        primary: "#8b1a29",
        "primary-1": "#1E88E5",
        secondary: "#424242",
        accent: "#82B1FF",
        info: "#2196F3",
        warning: "#FFC107",

        success: "#4CAF50",
        "success-70": "#388E3C",
        "success-90": "#1b5e20",

        error: "#FF5252",
        "error-90": "#8e0000",

        "grey-05": "#e0e0e0",
        "grey-10": "#bcbdbd",
        "grey-15": "#999999",
        "grey-23": "#5a5b5b",
        "grey-30": "#707070",

        "blue-60": "#4C6D82",
        "blue-70": "#355366",
        "blue-80": "#223947",
        "blue-90": "#092332",

        "orange-70": "#ff9800",

        "slate-10": "#f8fafc",
        "slate-50": "#64748b",
        "slate-60": "#334155",
        "slate-70": "#18181b",
        "slate-80": "#475569",
        "slate-90": "#0f172a",
      },
    },
  },
});
